export default __webpack_public_path__ + "images/0x18c11fd286c5ec11c3b683caa813b77f5163a122.png";